import React, {Component} from 'react';
import {Link} from 'react-router-dom'

class ReportMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (<div className="ui cards">

        <div className="card">
            <div className="content">
                <div className="description center aligned">
                    <i className="shopping bag huge icon"/><i className="user huge icon"/>
                </div>
                <div className="description center aligned">
                    &nbsp;
                </div>
                <div className="header">Commessa/Utente</div>
                <div className="description">
                    Produce un report in cui per ogni Commessa riporta il tempo impiegato da ciascun utente.

                </div>
            </div>
            <div className="extra content center aligned">
                <Link to={"/app/report/attivitacu"} className="ui basic green button">Vai al report</Link>
            </div>
        </div>

        <div className="card">
            <div className="content">
                <div className="description center aligned">
                    <i className="calendar huge icon"/><i className="clock huge icon"/>
                </div>
                <div className="description center aligned">
                    &nbsp;
                </div>
                <div className="header">Giorno/Sessioni</div>
                <div className="description">
                    Produce un report in cui per ogni giorno indica quanto tempo è stato impiegato per ciascuna commessa.
                </div>
            </div>
            <div className="extra content center aligned">
                <Link to={"/app/report/attivitags"} className="ui basic green button">Vai al report</Link>
            </div>
        </div>

        <div className="card">
            <div className="content">
                <div className="description center aligned">
                    <i className="shopping bag huge icon"/><i className="bar chart huge icon"/>
                </div>
                <div className="description center aligned">
                    &nbsp;
                </div>
                <div className="header">Resoconto Completo Commessa</div>
                <div className="description">
                    Scelta una Commessa e un periodo di tempo, genera un report completo della commessa, contenente le seguenti sezioni:
                    <ul>
                        <li>Attività svolte per operatore</li>
                        <li>Costi diretti</li>
                        <li>Costi indiretti</li>
                        <li>Fatture e Proforme emesse</li>
                        <li>Lettere e documenti prodotti</li>
                    </ul>
                </div>
            </div>
            <div className="extra content center aligned">
                <Link to={"/app/report/commesse"} className="ui basic green button">Vai al report</Link>
            </div>
        </div>

        <div className="card">
            <div className="content">
                <div className="description center aligned">
                    <i className="shopping bag huge icon"/><i className="euro sign huge icon"/>
                </div>
                <div className="description center aligned">
                    &nbsp;
                </div>
                <div className="header">Reddittività Commesse</div>
                <div className="description">
                    Calcolo della redditività delle commesse che hanno il flag <em>in_rendicontazione</em> impostato a 1.
                </div>
            </div>
            <div className="extra content center aligned">
                <Link to={"/app/report/reddittivita"} className="ui basic green button">Vai al report</Link>
            </div>
        </div>

      {/* Old Cards*/}
        {/*
      <div className="card">
        <div className="content">
          <div className="description center aligned">
            <i className="clock huge icon"/><i className="bar chart huge icon"/>
          </div>
          <div className="description center aligned">
            &nbsp;
          </div>
          <div className="header">Report Attività</div>
          <div className="description">
            Scelti un periodo di tempo e opzionalmente un utente e una commessa, visualizza il tempo totale speso per utente e commessa
            nel periodo scelto. Campi restituiti:
            <ul>
              <li>Commessa</li>
              <li>Utente</li>
              <li>Numero sessioni</li>
              <li>Tempo speso</li>
            </ul>
          </div>
        </div>
        <div className="extra content center aligned">
          <Link to={"/app/report/attivita"} className="ui basic green button">Vai al report</Link>
        </div>
      </div>

      <div className="card">
        <div className="content">
          <div className="description center aligned">
            <i className="clock huge icon"/><i className="area chart huge icon"/>
          </div>
          <div className="description center aligned">
            &nbsp;
          </div>
          <div className="header">Report Giornaliero Attività</div>
          <div className="description">Scelto un periodo di tempo, un utente e opzionalmente una commessa, visualizza il tempo totale speso per giorno e utente
            nel periodo scelto, diviso per ogni <b>GIORNO</b> compreso nell'intervallo stesso. Campi restituiti:
            <ul>
              <li>Giorno</li>
              <li>Utente</li>
              <li>Tempo speso</li>
            </ul>
          </div>
        </div>
        <div className="extra content center aligned">
          <Link to={"/app/report/attivitapergiorno"} className="ui basic green button">Vai al report</Link>
        </div>
      </div>

      <div className="card">
        <div className="content">
          <div className="description center aligned">
            <i className="clock huge icon"/><i className="area chart huge icon"/>
          </div>
          <div className="description center aligned">
            &nbsp;
          </div>
          <div className="header">Report Dettagliato Attività</div>
          <div className="description">
              Scelto un periodo di tempo, un utente e opzionalmente una commessa, visualizza le attività registrate per giorno, per utente e per commessa nel periodo scelto,
              diviso per ogni <b>GIORNO</b> compreso nell'intervallo stesso.
              Campi restituiti:
            <ul>
              <li>Giorno</li>
              <li>Commessa</li>
              <li>Utente</li>
              <li>Tempo speso</li>
              <li>Note</li>
            </ul>
          </div>
        </div>
        <div className="extra content center aligned">
          <Link to={"/app/report/attivitadettagliato"} className="ui basic green button">Vai al report</Link>
        </div>
      </div>

      <div className="card">
        <div className="content">
          <div className="description center aligned">
            <i className="clock huge icon"/><i className="bar chart huge icon"/>
          </div>
          <div className="description center aligned">
            &nbsp;
          </div>
          <div className="header">Report Annuale Attività</div>
          <div className="description">
            Scelto un periodo di tempo e opzionalmente un utente e una commessa,
              visualizza il tempo totale speso per commessa
            nel periodo scelto, diviso per ogni <b>ANNO</b> compreso nell'intervallo stesso. Campi restituiti:
            <ul>
              <li>Anno</li>
              <li>Commessa</li>
              <li>Numero sessioni</li>
              <li>Tempo speso</li>
            </ul>
          </div>
        </div>
        <div className="extra content center aligned">
          <Link to={"/app/report/attivitaperanno"} className="ui basic green button">Vai al report</Link>
        </div>
      </div>
/*}
{/*
      <div className="card">
        <div className="content">
          <div className="description center aligned">
            <i className="money huge icon"/><i className="bar chart huge icon"/>
          </div>
          <div className="description center aligned">
            &nbsp;
          </div>
          <div className="header">Report Movimenti per PDC</div>
          <div className="description">
            Elenco dei Movimenti registrati nel periodo scelto, raggruppati per Categoria, Voce e Sottovoce del Piano dei Conti.

          </div>
        </div>
        <div className="extra content center aligned">
          <Link to={"/app/report/movimenti"} className="ui basic green button">Vai al report</Link>
        </div>
      </div>

      <div className="card">
        <div className="content">
          <div className="description center aligned">
            <i className="money huge icon"/><i className="bar chart huge icon"/>
          </div>
          <div className="description center aligned">
            &nbsp;
          </div>
          <div className="header">Report Movimenti per EC</div>
          <div className="description">
            Elenco dei Movimenti registrati nel periodo scelto, raggruppati per <b>Estratto Conto</b> e Data.

          </div>
        </div>
        <div className="extra content center aligned">
          <Link to={"/app/report/movimentiec"} className="ui basic green button">Vai al report</Link>
        </div>
      </div>
*/}


    </div>)
  }
}

export default ReportMenu;




/** WEBPACK FOOTER **
 ** ./src/components/report/ReportMenu.js
 **/